<div class="app-container" dir="rtl">
  <header class="app-header">
    <div class="header-title">پارامترهای زنده - {{ title }}</div>
    <button class="back-btn" onclick="window.history.back()">
      <span>بازگشت</span>
      <span class="arrow">←</span>
    </button>
  </header>
  <main class="app-content">
    <div class="cards-grid" [@listAnimation]="charts.length">
      <ng-container *ngFor="let item of charts">
        <div class="card" [class.disabled-wrapper]="!item.strValue">
          <div class="card-top">
            <h3 class="card-title">{{ item.strComment }}</h3>
            <div class="card-icons">
              <ng-container *ngIf="item.CriticalValue">
                <div class="card-icon-circle">
                  <i
                    [ngClass]="returnStatusClass(item)"
                    class="fa fa-circle fa-lg"
                    title="وضعیت"
                  ></i>
                </div>
              </ng-container>
              <div class="card-icon-circle">
                <a
                  [href]="'https://fleetdiag.ir/pidhelp.html#' + item.strPID"
                  target="_blank"
                >
                  <i class="fa fa-info-circle fa-lg" title="راهنمای PID"></i>
                </a>
              </div>
              <ng-container *ngIf="item.bContinuousUpdate">
                <div class="card-icon-circle" (click)="toggleChart(item)">
                  <i class="fa fa-bar-chart" title="نمودار"></i>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="card-content">
            <div class="card-chart-area">
              <fleetdiag-dynamic-chart [data]="item" [chartData]="item.chartData"></fleetdiag-dynamic-chart>
            </div>
          </div>
          <div class="card-footer">
            <div class="card-icons">
              <div class="card-footer-icon" [class.bg-transparent]="!item.chartData?.length">
                <ng-container *ngIf="item.chartData?.length">
                  <i class="fa fa-table fa-lg" title="خروجی" (click)="exportExcel(item)"></i>
                </ng-container>
              </div>
              <div class="card-footer-icon" [class.bg-transparent]="!item.chartData?.length">
                <ng-container *ngIf="item.chartData?.length">
                  <i class="fa fa-expand fa-lg" title="تمام صفحه" (click)="openFullScreenChart(item)"></i>
                </ng-container>
              </div>
            </div>
            <div class="card-footer-time">
              <span class="text-white">
                {{ item.dtDateTime | date:'HH:mm:ss' }}.{{ item.dtDateTime.split('.')[1].substring(1,2) }}
                {{ item.strDateTime.split(' ')[0] }}
              </span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </main>
</div>
